var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/martech/Homepage/HomepageValuePropCTA/ProgressTracker.jsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import { Box, Paragraph, Heading, Image } from '@zillow/constellation';
import PropTypes from 'prop-types';
import { imageAlt, imageSrc } from '../utils/helper';

var ProgressBar = function ProgressBar(_ref) {
  var active = _ref.active,
      animationTime = _ref.animationTime,
      skipAnimation = _ref.skipAnimation;
  var BAR_WIDTH = '6px';
  var BORDER_RADIUS = 'calc($radii.sm / 2)';
  var INACTIVE_COLOR = '$colors.gray200';
  var ACTIVE_COLOR = '$colors.brand'; // Use `hasBeenActive` to avoid triggering the up slide animation on bars that have
  // never been active on the first place

  var _useState = useState(active),
      _useState2 = _slicedToArray(_useState, 2),
      hasBeenActive = _useState2[0],
      setHasBeenActive = _useState2[1];

  useEffect(function () {
    if (active && !hasBeenActive) {
      setHasBeenActive(true);
    }
  }, [active, hasBeenActive]);
  var css = {
    'width': BAR_WIDTH,
    'height': '100%',
    'background-color': !active && skipAnimation || !hasBeenActive ? INACTIVE_COLOR : ACTIVE_COLOR,
    'border-radius': BORDER_RADIUS
  };

  if (active && !skipAnimation) {
    css = Object.assign(Object.assign({}, css), {
      'animation': "progressAnimationStrike " + animationTime + "s",
      'animation-timing-function': '$animations.defaultTimingFunction',
      '@keyframes progressAnimationStrike': {
        from: {
          height: '0%'
        },
        to: {
          height: '100%'
        }
      }
    });
  } else if (!active && !skipAnimation && hasBeenActive) {
    css = {
      'width': BAR_WIDTH,
      'border-radius': BORDER_RADIUS,
      'background-color': '$colors.brand',
      'animation': "inActiveProgressAnimationStrike .5s",
      'animation-timing-function': '$animations.defaultTimingFunction',
      '@keyframes inActiveProgressAnimationStrike': {
        from: {
          height: '100%'
        },
        to: {
          height: '0%'
        }
      }
    };
  }

  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      'background-color': INACTIVE_COLOR,
      'border-radius': BORDER_RADIUS
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: css,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 13
    }
  }));
};

ProgressBar.propTypes = process.env.NODE_ENV !== "production" ? {
  active: PropTypes.bool,
  animationTime: PropTypes.number,
  skipAnimation: PropTypes.bool
} : {};
export var ListItemWithProgress = function ListItemWithProgress(_ref2) {
  var active = _ref2.active,
      heading = _ref2.heading,
      paragraph = _ref2.paragraph,
      animationTime = _ref2.animationTime,
      onClick = _ref2.onClick,
      skipAnimation = _ref2.skipAnimation;
  return /*#__PURE__*/React.createElement(Box, {
    onClick: onClick,
    sx: {
      cursor: 'pointer',
      display: 'flex',
      gap: '$spacing.md'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    animationTime: animationTime,
    active: active,
    skipAnimation: skipAnimation,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Box, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    fontColor: active ? 'brand' : 'textDark',
    level: "5",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 13
    }
  }, heading), /*#__PURE__*/React.createElement(Paragraph, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 13
    }
  }, paragraph)));
};
ListItemWithProgress.propTypes = process.env.NODE_ENV !== "production" ? {
  active: PropTypes.bool,
  heading: PropTypes.string,
  paragraph: PropTypes.string,
  animationTime: PropTypes.number,
  onClick: PropTypes.func,
  skipAnimation: PropTypes.bool
} : {};
var imageCss = {
  'animation-timing-function': 'cubic - bezier(0.65, 0, 0.35, 1)',
  'transition': '0.4s linear',
  'position': 'absolute',
  'maxWidth': '100%',
  'maxHeight': '100%'
};
var fadeInAnimation = {
  '@keyframes fadein': {
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    }
  },
  'animation': "fadein 500ms"
};
var fadeoutAnimation = {
  opacity: 0
};
export var ImageWithProgress = function ImageWithProgress(_ref3) {
  var active = _ref3.active,
      media = _ref3.media;
  var styles = Object.assign(Object.assign({}, imageCss), active ? fadeInAnimation : fadeoutAnimation);
  return /*#__PURE__*/React.createElement(Box, {
    as: Image,
    alt: imageAlt(media),
    src: imageSrc(media),
    sx: styles,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 129,
      columnNumber: 12
    }
  });
};
ImageWithProgress.propTypes = process.env.NODE_ENV !== "production" ? {
  active: PropTypes.bool,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  media: PropTypes.object
} : {};
export var ColumnImage = function ColumnImage(_ref4) {
  var media = _ref4.media,
      active = _ref4.active;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      'display': active ? 'flex' : 'none',
      'justifyContent': 'center',
      '@media $lg_gte': {
        display: 'none'
      },
      '> img': {
        position: 'relative',
        maxHeight: '300px'
      }
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ImageWithProgress, {
    key: imageSrc(media),
    active: active,
    media: media,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 150,
      columnNumber: 9
    }
  }));
};
ColumnImage.propTypes = process.env.NODE_ENV !== "production" ? {
  active: PropTypes.bool,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  media: PropTypes.object
} : {};